import type { FlashcardSet } from "@vita-learning/types";

export const FLASHCARD_SET_SOURCES: FlashcardSet["source"][] = [
	"file",
	"manual",
	"note",
	"url",
];
